import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "./msalConfig";
import {
  getMicrosoftUserProfile,
  commonLoginApi,
} from "../../services/authService";
import {
  InteractionStatus,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import {
  consumePendingRememberMePreference,
  persistAuthSession,
} from "./authStorage";
// export default function MicrosoftCallback() {
//   const { instance } = useMsal();
//   const navigate = useNavigate();

//   useEffect(() => {
//     (async () => {
//       const account =
//         instance.getActiveAccount() || instance.getAllAccounts()[0];

//       if (!account) {
//         navigate("/signin", { replace: true });
//         return;
//       }

//       instance.setActiveAccount(account);

//       const tokenResp = await instance.acquireTokenSilent({
//         ...loginRequest,
//         account,
//       });

//       const profile = await getMicrosoftUserProfile(tokenResp.accessToken);

//       const email =
//         (profile?.mail || "").trim() ||
//         (profile?.userPrincipalName || "").trim() ||
//         (account?.username || "").trim();

//       if (!email) {
//         navigate("/signin", { replace: true });
//         return;
//       }

//       const orgCode = sessionStorage.getItem("orgCode");
//       const organization = sessionStorage.getItem("organization");
//       const department = sessionStorage.getItem("department");

//       const obj =
//         orgCode && organization && department
//           ? { email, authType: "MICROSOFT", orgCode, organization, department }
//           : { email, authType: "MICROSOFT" };

//       const loginUserDetails = await commonLoginApi(obj);

//       if (loginUserDetails.code === 200) {
//         sessionStorage.setItem("JWT", loginUserDetails.data.token);
//         sessionStorage.setItem("email", loginUserDetails.data.email || email);
//         sessionStorage.setItem("accessLevel", loginUserDetails.data.access);

//         navigate("/portal-selector", { replace: true });
//       } else {
//         navigate("/signin", { replace: true });
//       }
//     })().catch(() => navigate("/signin", { replace: true }));
//   }, [instance, navigate]);

//   return <div>Signing you in…</div>;
// }
export default function MicrosoftCallback() {
  const { instance, inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;

    (async () => {
      const account =
        instance.getActiveAccount() || instance.getAllAccounts()[0];

      if (!account) {
        navigate("/signin", { replace: true });
        return;
      }

      instance.setActiveAccount(account);

      let tokenResp;
      try {
        tokenResp = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });
      } catch (e) {
        // ✅ if silent fails, re-run interactive safely (redirect)
        if (e instanceof InteractionRequiredAuthError) {
          await instance.acquireTokenRedirect({ ...loginRequest, account });
          return;
        }
        throw e;
      }

      const profile = await getMicrosoftUserProfile(tokenResp.accessToken);

      const email =
        (profile?.mail || "").trim() ||
        (profile?.userPrincipalName || "").trim() ||
        (account?.username || "").trim();
      const MSLoginId = profile?.id;

      if (!email) {
        navigate("/signin", { replace: true });
        return;
      }

      const orgCode = sessionStorage.getItem("orgCode");
      const organization = sessionStorage.getItem("organization");
      const department = sessionStorage.getItem("department");

      const obj =
        orgCode && organization && department
          ? {
              email,
              authType: "MICROSOFT",
              orgCode,
              organization,
              department,
              id: MSLoginId,
              token: tokenResp.accessToken,
            }
          : {
              email,
              authType: "MICROSOFT",
              id: MSLoginId,
              token: tokenResp.accessToken,
            };

      const loginUserDetails = await commonLoginApi(obj);

      if (loginUserDetails.code === 200) {
        persistAuthSession(
          {
            JWT: loginUserDetails?.data?.token,
            email: loginUserDetails?.data?.email || email,
            accessLevel: loginUserDetails?.data?.access,
            orgCode,
            organization,
            department,
            tenantId: loginUserDetails?.data?.tenantId,
            mainTenantId: loginUserDetails?.data?.tenantId,
            userName: loginUserDetails?.data?.userName,
            isFirstTimeUser: loginUserDetails?.data?.isSetupCompleted,
          },
          consumePendingRememberMePreference(),
        );
        navigate("/portal-selector", { replace: true });
      } else {
        navigate("/signin", { replace: true });
      }
    })().catch(() => navigate("/signin", { replace: true }));
  }, [instance, inProgress, navigate]);

  return <div>Signing you in…</div>;
}
